import React from 'react'
import Main from '../components/WelfarePage/Main'

const WelfarePage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default WelfarePage